<div class="flex flex-col">
  <div class="flex flex-col md:flex-row gap-6 md:gap-8 mb-8">
    @if (limitedTimeOfferIsLoading()) {
      <div class="relative min-h-[5rem] md:w-[42.5%]">
        <korviu-loader />
      </div>
    } @else {
      <div
        class="rounded-lg overflow-hidden flex flex-col h-[18.5rem] md:w-[42.5%] cursor-pointer"
        role="button"
        tabindex="0"
        (click)="onLimitedTimeOfferClick()"
        (keydown.enter)="onLimitedTimeOfferClick()"
        (keydown.space)="$event.preventDefault(); onLimitedTimeOfferClick()"
      >
        <div class="flex-1 bg-[#E6F2F1] relative">
          @if (limitedTimeOffer()?.image) {
            <img [src]="limitedTimeOffer()?.image" alt="" class="w-full h-full object-cover rounded-t-lg" />
          }
          <div class="absolute top-4 left-4">
            <app-tag type="success">{{ 'rewards.limitedTimeOffer' | translate }}</app-tag>
          </div>
          @if (limitedTimeOffer()) {
            <button
              type="button"
              class="limited-time-offer-favorite absolute top-4 right-4 size-8 flex items-center justify-center"
              [attr.aria-pressed]="limitedTimeOffer()?.is_favorite"
              (click)="onLimitedTimeOfferFavoriteClick($event)"
              (keydown.enter)="$event.stopPropagation()"
              (keydown.space)="$event.stopPropagation()"
            >
              <i>
                @if (limitedTimeOffer()?.is_favorite) {
                  <svg xmlns="http://www.w3.org/2000/svg" width="27" height="24" viewBox="0 0 27 24" fill="none">
                    <path
                      d="M14.4262 2.10289L13.3319 3.19957L12.2342 2.1019C9.43551 -0.696857 4.89782 -0.696857 2.09907 2.1019C-0.69969 4.90065 -0.69969 9.43833 2.09907 12.2371L12.6262 22.7642C13.0167 23.1547 13.6499 23.1547 14.0405 22.7642L24.5757 12.2351C27.3682 9.42713 27.373 4.90216 24.5738 2.10289C21.7699 -0.700963 17.2301 -0.700963 14.4262 2.10289Z"
                      fill="#CB2222"
                    />
                  </svg>
                } @else {
                  <svg xmlns="http://www.w3.org/2000/svg" width="27" height="24" viewBox="0 0 27 24" fill="none">
                    <path
                      d="M14.4262 2.10289L13.3319 3.19957L12.2342 2.1019C9.43551 -0.696857 4.89782 -0.696857 2.09907 2.1019C-0.69969 4.90065 -0.69969 9.43833 2.09907 12.2371L12.6262 22.7642C13.0167 23.1547 13.6499 23.1547 14.0405 22.7642L24.5757 12.2351C27.3682 9.42713 27.373 4.90216 24.5738 2.10289C21.7699 -0.700963 17.2301 -0.700963 14.4262 2.10289ZM23.1575 10.8249L13.3333 20.643L3.51328 10.8229C1.49556 8.80513 1.49556 5.53382 3.51328 3.51612C5.53099 1.4984 8.80234 1.4984 10.8201 3.51612L12.6299 5.32604C13.0271 5.7232 13.6734 5.71545 14.0609 5.3089L15.8405 3.5171C17.8633 1.4943 21.1367 1.4943 23.1595 3.5171C25.1778 5.5353 25.1743 8.797 23.1575 10.8249Z"
                      fill="#AFB2B6"
                    />
                  </svg>
                }
              </i>
            </button>
          }
        </div>
        <div class="product-bottom px-6 pt-4 pb-6 flex flex-col gap-6">
          <span class="text-[#222528] text-[1.1875rem] font-bold">
            {{ isEnglish() ? limitedTimeOffer()?.name : limitedTimeOffer()?.name_es }}
          </span>
          <div class="flex items-center gap-4">
            <div class="rounded-lg p-2 bg-[#E6F2F1] size-10 flex items-center justify-center">
              <i>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="30" viewBox="0 0 20 30" fill="none">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.0536 27.3354C15.0149 24.5804 17.8621 19.5871 17.8621 14.3834C17.8621 11.6478 17.0008 9.54148 15.6629 8.13389C14.3329 6.73464 12.3888 5.87304 9.91052 5.87304C7.40177 5.87304 5.46262 6.70002 4.14795 8.06248C2.82825 9.43016 1.95897 11.5241 1.95897 14.3834C1.95897 19.587 4.80641 24.5803 9.7675 27.3354C9.85661 27.3848 9.96449 27.3848 10.0536 27.3354ZM11.0046 29.048C16.5775 25.9534 19.821 20.3106 19.821 14.3834C19.821 8.0782 15.8226 3.91406 9.91052 3.91406C3.99849 3.91406 0 7.85937 0 14.3834C0 20.3106 3.24385 25.9534 8.81644 29.048C9.49703 29.4259 10.324 29.4259 11.0046 29.048Z"
                    fill="#017F70"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.2506 0.18339C11.6903 0.498485 11.7914 1.11038 11.4763 1.55009C10.9158 2.33221 10.5971 3.44084 10.5167 4.63668C10.4367 5.82713 10.6007 6.99603 10.9003 7.83196C11.0828 8.34119 10.818 8.90197 10.3088 9.08451C9.79953 9.26704 9.23875 9.0022 9.05622 8.49297C8.65366 7.36992 8.46663 5.92686 8.56215 4.50534C8.65731 3.08923 9.0406 1.58588 9.88392 0.409031C10.199 -0.0306822 10.8109 -0.131705 11.2506 0.18339Z"
                    fill="#017F70"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.01147 13.7909C7.59668 14.3034 7.34267 15.0754 7.34267 16.0294C7.34267 16.9835 7.59668 17.7554 8.01147 18.2679C8.40464 18.7537 9.00404 19.087 9.91083 19.087C10.8176 19.087 11.417 18.7537 11.8102 18.2679C12.225 17.7554 12.479 16.9835 12.479 16.0294C12.479 15.0754 12.225 14.3034 11.8102 13.7909C11.417 13.3052 10.8176 12.9718 9.91083 12.9718C9.00404 12.9718 8.40464 13.3052 8.01147 13.7909ZM6.48787 12.5578C7.27744 11.5822 8.45215 11.0117 9.91083 11.0117C11.3695 11.0117 12.5442 11.5822 13.3338 12.5578C14.1017 13.5066 14.4391 14.7535 14.4391 16.0294C14.4391 17.3053 14.1017 18.5522 13.3338 19.501C12.5442 20.4766 11.3695 21.0471 9.91083 21.0471C8.45215 21.0471 7.27744 20.4766 6.48787 19.501C5.71993 18.5522 5.38257 17.3053 5.38257 16.0294C5.38257 14.7535 5.71993 13.5066 6.48787 12.5578Z"
                    fill="#017F70"
                  />
                </svg>
              </i>
            </div>
            <span class="text-[#017F70] text-[1.75rem] font-bold">
              {{ +limitedTimeOffer()?.price }} {{ 'rewards.ganas' | translate }}
            </span>
          </div>
        </div>
      </div>
    }

    <!-- For you -->
    <div class="flex flex-col gap-4 flex-1">
      <div class="flex items-center justify-between">
        <div class="flex flex-col w-full md:w-auto items-start">
          <span class="text-[#222528] text-[1.1875rem] font-bold">{{ 'rewards.recentTransactions' | translate }}</span>
          <span class="text-[#007DCB] text-[1rem]">{{ 'rewards.yourRecentlyRedeemedRewards' | translate }}</span>
        </div>
        <div
          class="text-[#007DCB] text-[1rem] cursor-pointer text-center text-nowrap"
          (click)="onViewAllTransactionsClick()"
        >
          {{ 'rewards.viewAll' | translate }}
        </div>
      </div>
      <div class="flex flex-col gap-4">
        <div class="text-[#505760] text-[1.125rem] flex flex-col gap-4 items-center mx-auto min-h-[3rem]">
          <i>
            <svg xmlns="http://www.w3.org/2000/svg" width="124" height="124" viewBox="0 0 124 124" fill="none">
              <path
                d="M100.75 62V96.875C100.75 97.9027 100.342 98.8883 99.615 99.615C98.8883 100.342 97.9027 100.75 96.875 100.75H27.125C26.0973 100.75 25.1117 100.342 24.385 99.615C23.6583 98.8883 23.25 97.9027 23.25 96.875V62H100.75Z"
                fill="#EEEEEF"
              />
              <path
                d="M107.75 42.625C107.75 40.8991 106.351 39.5 104.625 39.5H19.375C17.6491 39.5 16.25 40.8991 16.25 42.625V58.125C16.25 59.8509 17.6491 61.25 19.375 61.25H104.625C106.351 61.25 107.75 59.8509 107.75 58.125V42.625ZM109.25 58.125C109.25 60.6793 107.179 62.75 104.625 62.75H19.375C16.8207 62.75 14.75 60.6793 14.75 58.125V42.625C14.75 40.0707 16.8207 38 19.375 38H104.625C107.179 38 109.25 40.0707 109.25 42.625V58.125Z"
                fill="#C9CBCE"
              />
              <path
                d="M22.5 96.875V62C22.5 61.5858 22.8358 61.25 23.25 61.25C23.6642 61.25 24 61.5858 24 62V96.875C24 97.7038 24.329 98.4989 24.915 99.085C25.5011 99.671 26.2962 100 27.125 100H96.875C97.7038 100 98.4989 99.671 99.085 99.085C99.671 98.4989 100 97.7038 100 96.875V62C100 61.5858 100.336 61.25 100.75 61.25C101.164 61.25 101.5 61.5858 101.5 62V96.875C101.5 98.1016 101.013 99.2782 100.146 100.146C99.2782 101.013 98.1016 101.5 96.875 101.5H27.125C25.8984 101.5 24.7218 101.013 23.8545 100.146C22.9871 99.2782 22.5 98.1016 22.5 96.875Z"
                fill="#C9CBCE"
              />
              <path
                d="M61.25 100.75V38.75C61.25 38.3358 61.5858 38 62 38C62.4142 38 62.75 38.3358 62.75 38.75V100.75C62.75 101.164 62.4142 101.5 62 101.5C61.5858 101.5 61.25 101.164 61.25 100.75Z"
                fill="#C9CBCE"
              />
              <path
                d="M68.7041 14.6214C73.2591 9.46257 81.3779 9.80325 86.1631 14.5882C90.8743 19.2994 91.2765 27.2401 86.3682 31.8451L86.1299 32.0619C81.8794 35.8247 75.8063 37.6685 70.8818 38.5824C68.4061 39.0418 66.1911 39.2713 64.5947 39.3861C63.7963 39.4435 63.1511 39.4722 62.7041 39.4867C62.4805 39.4939 62.3056 39.4975 62.1865 39.4994C62.1272 39.5003 62.0811 39.5011 62.0498 39.5013H62.001C61.8021 39.5013 61.6104 39.4222 61.4697 39.2816C61.3292 39.141 61.25 38.9502 61.25 38.7513V38.7015C61.2502 38.6701 61.251 38.6243 61.252 38.5648C61.2538 38.4457 61.2574 38.2716 61.2646 38.0482C61.2791 37.6011 61.3077 36.9553 61.3652 36.1566C61.4803 34.5602 61.7106 32.3452 62.1709 29.8695C63.0866 24.9449 64.9339 18.8719 68.7041 14.6214ZM85.1025 15.6498C80.8399 11.3871 73.7305 11.1947 69.8281 15.6156L69.8271 15.6166C66.332 19.5567 64.5462 25.3 63.6455 30.1439C63.1977 32.5523 62.9734 34.7102 62.8613 36.265C62.8101 36.9758 62.7826 37.5597 62.7676 37.9828C63.1908 37.9678 63.7756 37.9412 64.4873 37.89C66.0422 37.7782 68.2001 37.5547 70.6084 37.1078C75.4524 36.2088 81.1957 34.4269 85.1357 30.9388C89.558 27.0214 89.3642 19.9117 85.1025 15.6498Z"
                fill="#C9CBCE"
              />
              <path
                d="M37.8365 14.5882C42.6216 9.80314 50.7405 9.46268 55.2955 14.6214L55.6432 15.0248C59.1804 19.25 60.9416 25.0987 61.8287 29.8695C62.2891 32.3452 62.5194 34.5601 62.6344 36.1566C62.6919 36.9553 62.7205 37.6011 62.735 38.0482C62.7422 38.2716 62.7458 38.4457 62.7477 38.5648C62.7486 38.6243 62.7494 38.6701 62.7496 38.7015V38.7513L62.735 38.8988C62.7061 39.0429 62.6353 39.1762 62.5299 39.2816C62.4245 39.387 62.2912 39.4578 62.1471 39.4867L61.9996 39.5013H61.9498C61.9185 39.5011 61.8726 39.5003 61.8131 39.4994C61.694 39.4975 61.5199 39.4939 61.2965 39.4867C60.8496 39.4722 60.2044 39.4435 59.4059 39.3861C57.8095 39.2713 55.5945 39.0418 53.1188 38.5824C48.1942 37.6685 42.1203 35.8248 37.8698 32.0619C32.7118 27.493 33.0505 19.3742 37.8365 14.5882ZM54.1725 15.6156C50.2701 11.1947 43.1607 11.3871 38.8981 15.6498C34.636 19.9118 34.4421 27.0214 38.8649 30.9388C42.8051 34.4269 48.5482 36.2089 53.3922 37.1078C55.8006 37.5547 57.9585 37.7782 59.5133 37.89C60.2242 37.9411 60.808 37.9678 61.2311 37.9828C61.2161 37.5597 61.1895 36.9758 61.1383 36.265C61.0263 34.7101 60.802 32.5523 60.3541 30.1439C59.4534 25.3 57.6686 19.5567 54.1735 15.6166L54.1725 15.6156Z"
                fill="#C9CBCE"
              />
            </svg>
          </i>
          <span class="text-[#737980] text-[0.8125rem] md:text-[0.9375rem]">{{
            'rewards.tapIntoYourGanas' | translate
          }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Featured -->
  @if (featured()?.length) {
    <div class="flex flex-col gap-4 mb-8">
      <div class="flex items-center justify-between">
        <span class="text-[#222528] text-[1.1875rem] font-bold">{{ 'rewards.featured' | translate }}</span>
        <button
          type="button"
          class="text-[#007DCB] text-[1rem] cursor-pointer text-center"
          (click)="onFeaturedViewAllClick()"
        >
          {{ 'rewards.viewAll' | translate }}
        </button>
      </div>
      @if (featuredIsLoading()) {
        <div class="relative min-h-[5rem] w-full">
          <korviu-loader></korviu-loader>
        </div>
      } @else {
        <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
          @for (product of featured()?.slice(0, popularInCommunity()?.length ? 4 : 8); track product.id) {
            <app-product-card
              [isFavorite]="product.is_favorite"
              [name]="isEnglish() ? product.name : product.name_es"
              [category]="isEnglish() ? product.categories[0]?.name : product.categories[0]?.name_es"
              [price]="+product.price"
              [image]="product.image"
              [productId]="product.id"
              [label]="product.label?.toLowerCase()"
            />
          }
        </div>
      }
    </div>
  }

  <!-- Popular in your community -->
  @if (popularInCommunity()?.length) {
    <div class="flex flex-col gap-4 mb-8">
      <div class="flex items-center justify-between">
        <span class="text-[#222528] text-[1.1875rem] font-bold">{{
          'rewards.popularInYourCommunity' | translate
        }}</span>
        <button
          type="button"
          class="text-[#007DCB] text-[1rem] cursor-pointer text-center"
          (click)="onPopularInCommunityViewAllClick()"
        >
          {{ 'rewards.viewAll' | translate }}
        </button>
      </div>
      @if (popularInCommunityIsLoading()) {
        <div class="relative min-h-[5rem] w-full">
          <korviu-loader></korviu-loader>
        </div>
      } @else {
        <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
          @for (product of popularInCommunity()?.slice(0, featured()?.length ? 4 : 8); track product.id) {
            <app-product-card
              [isFavorite]="product.is_favorite"
              [name]="isEnglish() ? product.name : product.name_es"
              [category]="isEnglish() ? product.categories[0]?.name : product.categories[0]?.name_es"
              [price]="+product.price"
              [image]="product.image"
              [productId]="product.id"
            />
          }
        </div>
      }
    </div>
  }
</div>
